export default __webpack_public_path__ + "static/media/Thumb_Glasses_06.d19ced10.png";